import { useState, useRef, useEffect, useCallback } from "react";
// ** Reactstrap Imports
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { Link,useNavigate } from "react-router-dom";
import { BiLeftArrowAlt } from "react-icons/bi";

import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats } from "../../utils/EditorToolbar";
import 'react-quill/dist/quill.snow.css';
import useAuth from '../../hooks/useAuth';
import { MdOutlineAdd, MdRemove } from 'react-icons/md';
import { v4 as uuidv4 } from 'uuid';

const AddInvestmentDisburse = () => {

  const { auth } = useAuth();
  const navigate = useNavigate();

  // ** States
  let initialState = {
    invServiceTitle: "",
    invServiceSubTitle: "",
    hasDisburseFeature: 0,
    hasClientExpense: 0
  };
  const [investmentInfo, setInvestmentInfo] = useState(initialState);
  const [hasExpense, setHasExpense] = useState(false); 
  const [isSchedule, setIsSchedule] = useState(false);

  const [invTitleList, setInvTitle] = useState([{ id: uuidv4(), invServiceTitle: ''}])
  const [invSubTitleList, setInvSubTitle] = useState([{ id: uuidv4(), invServiceSubTitle: ''}])

  // Title Section

  const handleTitleChange = (index, e ) => {
    const { name, value } = e.target;
   
     const newInputFields = invTitleList.map(i => {
      if(index === i.id) {
        i[name] = value
      }
      return i;
    })
    
    setInvTitle(newInputFields);
  };


  const handleRemoveTitleField = (index) => {
    const list = [...invTitleList];
    list.splice(index, 1);
    setInvTitle(list);
  };

  const handleAddTitleField = () => {
    setInvTitle([...invTitleList, { id: uuidv4(), invServiceTitle: "" }]);
  };


  // Subtitle Section

  const handleSubtitleChange = ( index, e) => {
    const { name, value } = e.target;

    const newSubtitle = invSubTitleList.map(i => {
      if(index === i.id) {
        i[name] = value
      }
      return i;
    })
    setInvSubTitle(newSubtitle);
  };

  const handleRemoveSubTitleField = (index) => {
    const list = [...invSubTitleList];
    list.splice(index, 1);
    setInvSubTitle(list);
  };

  const handleAddSubTitleField = () => {
    setInvSubTitle([...invSubTitleList, { id: uuidv4(), invServiceSubTitle: "" }]);
  };

  const allTitles = Array.prototype.map.call(invTitleList, function(item) { return item.invServiceTitle; }).join(",");
  const allSubtitles = Array.prototype.map.call(invSubTitleList, function(item) { return item.invServiceSubTitle; }).join(",");

  const handleChange = (event) => {
    const { value, name } = event.target;
    setInvestmentInfo((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  const ondescription = (value) => {
    setInvestmentInfo({ ...investmentInfo,
        investServiceDesc:value
    });
  } 



  const handleSaveClick = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("invServiceTitle", allTitles);
    formData.append("invServiceSubTitle", allSubtitles);
    formData.append("investServiceDesc", investmentInfo.investServiceDesc);
    formData.append("monthlyFee", investmentInfo.monthlyFee);
    formData.append("hasClientExpense", hasExpense);
    formData.append("hasDisburseFeature",  isSchedule);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/investment/disburse/save`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " + auth.accessToken,
          },
        }
      );

      setInvestmentInfo(initialState);
      setHasExpense(false);
      setIsSchedule(false);
      toast.success(res.data.message, {
        className: "success-toast",
        autoClose: 3000,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      navigate('/investment/additional-disburse/view')

    } catch (error) {
      error.response.data.message
        ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          })
        : toast.error(error.response.data.error, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          });
    }
  };

  const handleReset = async (event) => {
    event.preventDefault();
      setInvestmentInfo(initialState);
      setHasExpense(false);
      setIsSchedule(false);
  };

  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Add Investment</h5>
      </Row>
      <Row sm="12">
        <Card>
          <CardBody>
            <Col sm="12" className="mb-2">
              <Form>
               
                <div className='mb-1'>
                  <Label className="form-label" for="invServiceTitle">
                    Investment Title <span className="text-danger">*</span>
                  </Label>
              { invTitleList.map((inputField, index) => (
                    <Row key={inputField.id}>
                        <Col sm='12' md='10' lg='10'>
                        <div>
                            <Input
                                id='invServiceTitle'
                                type='text'
                                name="invServiceTitle"
                                className="my-2"
                                value={inputField.invServiceTitle}
                                onChange={event => handleTitleChange(inputField.id, event)}
                                required={true}
                            />  
                        </div>
                        </Col>
                        <Col sm='12' md='1' lg='1'>
                        <div className='mb-2'>

                        {
                          invTitleList && invTitleList.length - 1 === index && (
                            <Button
                                block
                                color="success"
                                className="my-2"
                                onClick={handleAddTitleField}
                                >
                                <MdOutlineAdd />
                            </Button>
                          )
                        }
                        
                        
                        </div>

                        </Col>
                        <Col sm='12' md='1' lg='1'>
                        <div>
                        {
                          invTitleList.length > 1 &&  <Button
                                block
                                color="danger"
                                className="my-2"
                                onClick={() => handleRemoveTitleField(index)}
                                >
                                <MdRemove />
                            </Button>
                        }
                           
                        </div>
                        </Col>
                    </Row>
                   
                    )) 
                }
                </div>


                <div className='mb-1'>
                <Label className="form-label" for="invServiceSubTitle">
                        Investment Subtitle <span className="text-danger">*</span>
                      </Label>
                  { invSubTitleList.map((inputField, index) => (
                        <Row key={inputField.id}>
                              <Col sm='12' md='10' lg='10'>
                            <div>
                                <Input
                                    id='invServiceSubTitle'
                                    type='text'
                                    className="my-2"
                                    name="invServiceSubTitle"
                                    value={inputField.invServiceSubTitle}
                                    onChange={event => handleSubtitleChange(inputField.id, event)}
                                    required={true}
                                />  
                            </div>
                            </Col>
                            <Col sm='12' md='1' lg='1'>
                            <div>
                            {
                              invSubTitleList && invSubTitleList.length - 1 === index && (
                                <Button
                                    block
                                    color="success"
                                    className="my-2"
                                    onClick={handleAddSubTitleField}
                                    >
                                    <MdOutlineAdd />
                                </Button>
                              )
                            }
                              
                            </div>
                            </Col>
                            <Col sm='12' md='1' lg='1'>
                            <div className='mb-2'>
                            {
                              invSubTitleList.length > 1 &&  <Button
                                    block
                                    color="danger"
                                    className="my-2"
                                    onClick={() => handleRemoveSubTitleField(index)}
                                    >
                                    <MdRemove />
                                </Button>
                            }
                              
                            </div>
                            </Col>
                        </Row>
                      
                        )) 
                    }
                </div>


                {/* <div className="mb-1">
                  <Label className="form-label" for="investmentDescription">
                    Investment Description <span className="text-danger">*</span>
                  </Label>
                  <EditorToolbar toolbarId={'t1'} />
                    <ReactQuill 
                    theme="snow"  
                    id="investmentDescription"                  
                    value={investmentInfo.investServiceDesc || ''}
                    onChange={ondescription}                 
                    placeholder={"Write something awesome..."}
                    modules={modules('t1')}
                    formats={formats}
                    />
                </div> */}

                <div className="mb-1">
                <Input type="checkbox"  id="expense" name="expense" onClick={(e) => setHasExpense(e.target.checked)} />    
                  <Label className="mx-5 form-label" for="schedule">
                  Is Additional Disbursement Clients Expense?<span className="text-danger">*</span>
                  </Label>
                 
                </div>

                <div className="mb-1">
                <Input type="checkbox"   id="schedule"  name="schedule"
                                                             onClick={(e) => setIsSchedule(e.target.checked)}        />
                  <Label className=" mx-5 form-label" for="expense">
                  Is Included? <span className="text-danger">*</span>
                  </Label>
                
                </div>



                <Row className="pt-2">
                  <Col>
                    <div className="mb-1">
                      <Button
                        block
                        color="success"
                        type="submit"
                        onClick={handleSaveClick}
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                  <Col>
                    <div className="mb-1">
                      <Button block color="warning" onClick={handleReset}>
                        Reset
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </CardBody>
        </Card>
      </Row>

      <Row sm="12" className="mt-4 text-center">
        <Link to={"/investment/additional-disburse/view"} className="go_back">
          <BiLeftArrowAlt size={30} /> Go to Investment List
        </Link>
      </Row>
    </div>
  );
};

export default AddInvestmentDisburse;
